import { Component, OnInit } from '@angular/core';
import { BankingService } from '../../services/banking.service';

@Component({
    selector: 'app-banking',
    templateUrl: './banking.component.html',
    styleUrls: ['./banking.component.scss'],
    standalone: true,
    imports: []
})
export class BankingComponent implements OnInit {
  transactions: any[] = [];
  accessToken: string = '';

  constructor(private bankingService: BankingService) {}

  ngOnInit() {
    this.initializePlaidLink();
  }

  initializePlaidLink() {
    // Fetch link_token from the backend
    this.bankingService.createLinkToken().subscribe(
      (response: any) => {
        const linkToken = response.link_token;
        const linkHandler = (window as any).Plaid.create({
          token: linkToken,
          onSuccess: (public_token: string, metadata: any) => {
            this.onPlaidSuccess({ token: public_token, metadata });
          },
          onExit: (err: any, metadata: any) => {
            this.onPlaidExit({ err, metadata });
          },
          onEvent: (eventName: string, metadata: any) => {
            // Plaid Link event — no logging to avoid exposing institution/account metadata
          },
        });
        // Open Plaid Link UI when the user clicks a button (or auto-open)
        linkHandler.open();
      },
      (error) => {
        console.error('Error fetching link token:', error);
      }
    );
  }

  onPlaidSuccess(event: any) {
    const public_token = event.token;
    this.bankingService.exchangePublicToken(public_token).subscribe(
      (response: any) => {
        this.accessToken = response.access_token;
        this.bankingService.getTransactions(this.accessToken).subscribe(
          (data: any) => {
            this.transactions = data.transactions;
          },
          (error) => {
            console.error('Error fetching transactions:', error);
          }
        );
      },
      (error) => {
        console.error('Error exchanging public token:', error);
      }
    );
  }

  onPlaidExit(event: any) {
    // Plaid Link exited
  }
}